module.exports = __webpack_public_path__ + "img/logo_bodenseekreis.a67f5863.png";